import React from "react";
import QuizManager from "./QuizManager";
import AppointmentManager from "./AppointmentManager";
import TeacherManager from "./TeacherManager";
import ProfilePicture from "./ProfilePicture";
import RetakeSubmissionManager from "./RetakeSubmissionManager";
import FacultyClassesTable from "./FacultyClassesTable";
import { RolesDragdown } from "./RolesDragdown";
import '../App.css'; // Import the CSS file

function Dashboard(props) {
  if (props.title === "Admin Dashboard") {
    return (
      <div className="Profile">
        <h2>{props.title}</h2>
        <ProfilePicture />
        <TeacherManager
          title="Teachers Pending Approval"
          data={props.teacherdata}
        />
      </div>
    );
  } else {
    return (
      <div className="Profile">
        <RolesDragdown/>
        <h2>{props.title}</h2>
        <ProfilePicture />
        <QuizManager
          title="My Quizzes"
          data={props.quizData}
          className="dashboard-title"
        />
        {/* <AppointmentManager title="Appointments" data={props.appointmentData} /> */}
        <RetakeSubmissionManager title="All Appointments" data={props.submissionData} />
        {props.classData && (
          <div>
            <h2>My Classes</h2>
            {props.classData}
          </div>
        )}
      </div>
    );
  }
}

export default Dashboard;





// import React from "react";
// import { useAuth, login, logout } from "../firebase/auth";

// // Import Dashboard Components
// import QuizManager from "./QuizManager";
// import AppointmentManager from "./AppointmentManager";
// import TeacherManager from "./TeacherManager";
// import ProfilePicture from "./ProfilePicture";
// import RetakeSubmissionManager from "./RetakeSubmissionManager";
// import FacultyClassesTable from "./FacultyClassesTable";
// import { RolesDragdown } from "./RolesDragdown";

// const Dashboard = (props) => {
//   const { currentUser } = useAuth();

//   if (!currentUser) {
//     return (

//       <div>
//         <h1>Please log in to access your dashboard.</h1>
//         <button onClick={() => login("test@example.com", "password123")}>Login</button>
        

//       <div className="Profile">
//         <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
//           <RolesDragdown />
//         </div>
//         <h2>{props.title}</h2>
//         <ProfilePicture />
//         <QuizManager title="My Quizzes" data={props.quizData} />
//         <AppointmentManager title="Appointments" data={props.appointmentData} />
//         <RetakeSubmissionManager title="Retake Sign Ups" data={props.submissionData} />
//         {props.classData && (
//           <div>
//             <h2>My Classes</h2>
//             {props.classData}
//           </div>
//         )}

//       </div>
//     );
//   }

//   return (
//     <div className="Profile">
//       <h2>Welcome, {currentUser.displayName || currentUser.email}!</h2>
//       <button onClick={logout}>Logout</button>
//       <ProfilePicture />

//       {/* Admin Dashboard: Teacher Approval */}
//       {props.title === "Admin Dashboard" ? (
//         <TeacherManager title="Teachers Pending Approval" data={props.teacherdata} />
//       ) : (
//         <>
//           {/* Faculty Dashboard: Quizzes, Appointments, Retakes, and Classes */}
//           <QuizManager title="My Quizzes" data={props.quizData} />
//           <AppointmentManager title="Appointments" data={props.appointmentData} />
//           <RetakeSubmissionManager title="Retake Sign Ups" data={props.submissionData} />

//           {props.classData && (
//             <div>
//               <h2>My Classes</h2>
//               <FacultyClassesTable data={props.classData} />
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// export default Dashboard;
